import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'headerModelValue'
})
export class HeaderModelValuePipe implements PipeTransform {

  transform(selectedType: string, columnName: string, studentCollectionTeamMemberPermission: any[]): string {
    const editableForm = [];
    const viewForm = [];
    studentCollectionTeamMemberPermission.forEach(x => {
      Object.keys(x).forEach(l => {
        if (l == columnName) {
          if (x[columnName] == 'True') {
            editableForm.push(x[columnName]);
          }
          if (x[columnName] == 'False') {
            viewForm.push(x[columnName]);
          }
        }
      });
    });
    if (editableForm.length == studentCollectionTeamMemberPermission.length) {
      return 'True';
    } else if (viewForm.length == studentCollectionTeamMemberPermission.length) {
      return 'False';
    } else {
      return 'viewEdit';
    }
  }
}
